export default __webpack_public_path__ + "static/media/trr-drink-coffeecocktail-espressomartini.75b220b2.png";